import { createContext } from 'react';

/** 详情页滚动容器（.img2img-detail__main 或虚拟列表），供 SignedImage 视口懒加载绑定 */
const DetailPageScrollContext = createContext(null);

export default DetailPageScrollContext;
